// create guid
var guid = (function() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return function() {
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
			s4() + '-' + s4() + s4() + s4();
	};
})();

// generic sort function
var sort_by = function(field, reverse, primer) {
	var key = function(x) {
		return primer ? primer(x[field]) : x[field]
	};

	return function(a, b) {
		var A = key(a),
			B = key(b);
		return ((A < B) ? -1 : ((A > B) ? 1 : 0)) * [-1, 1][+!!reverse];
	}
}

//used to adjust textarea to fit their content
var autoAdjustTextarea = function(element) {
	try {
		if (element) {
			//element appears to have 0 scrollHeight when hidden (parent is hidden etc)
			if (element.scrollHeight > 0) {
				element.style.overflow = 'hidden';
				element.style.height = 0;
				if (element.scrollHeight > 40) {
					element.style.height = element.scrollHeight + 'px';
				} else {
					element.style.height = 40 + 'px';
				}
			}
		}
	} catch (e) {}
};